// Display a number using en-US international format (1,234.56), trimming trailing zeros.
// Pass strings, numbers, or null — returns '' for empty/invalid.
export const formatNumber = (val, opts = {}) => {
  if (val === null || val === undefined || val === '') return '';
  const num = typeof val === 'number' ? val : parseFloat(val);
  if (isNaN(num)) return String(val);
  const { maxDecimals = 6, minDecimals = 0, useGrouping = true } = opts;
  return new Intl.NumberFormat('en-US', {
    minimumFractionDigits: minDecimals,
    maximumFractionDigits: maxDecimals,
    useGrouping,
  }).format(num);
};

// For populating edit inputs (type=number). Strips trailing zeros, returns string with dot decimal.
export const numberInputValue = (val) => {
  if (val === null || val === undefined || val === '') return '';
  const num = typeof val === 'number' ? val : parseFloat(val);
  if (isNaN(num)) return '';
  return String(num);
};
